import { ExternalLink } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const embedFor = (q) => `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=17&output=embed`;

// Google refuses to show normal "place" links inside other sites, so convert them to an embed URL.
export function mapEmbedSrc(url, address) {
  if (!url) return address ? embedFor(address) : "";
  if (url.includes("output=embed") || url.includes("/maps/embed")) return url;
  const pin = url.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/) || url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (pin) return embedFor(`${pin[1]},${pin[2]}`);
  return address ? embedFor(address) : "";
}

export const MapEmbed = ({ className = "h-72 md:h-full min-h-[18rem]" }) => {
  const { settings } = useSite();
  const src = mapEmbedSrc(settings.map_embed_url, settings.address);
  return (
    <div className={`relative overflow-hidden rounded-3xl bg-brand-tint2 ring-1 ring-slate-200 ${className}`}>
      {src && (
        <iframe
          title="Map showing the location of Young Spine Tricity clinic in Mohali"
          src={src}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0 h-full w-full border-0"
          data-testid="clinic-map-embed"
        />
      )}
      <a
        href={settings.map_link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="map-directions-link"
        className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-brand-blue shadow-md hover:bg-brand-tint"
      >
        Get directions <ExternalLink className="h-4 w-4" aria-hidden="true" />
      </a>
    </div>
  );
};
